<template>
    <div class="sports__grid">

        <div class="sports__buttons">

            <button class="general-button rounded-corners"
                    @click="allOrder"
                    :class='{ "selected-sorted": isFirstLoad || this.sport_type === "" || this.sport_type.length < 0 }'>
                {{ printString('all_sports') }}
            </button>

            <button v-for="term in sport_types"
                    :key="term.term_id"
                    class="general-button rounded-corners"
                    @click="filterByType(term.term_id)"
                    :class="{ 'selected-sorted': this.sport_type === term.term_id.toString() }"
                     v-html="term.name">

            </button>

        </div>


        <div class="sports__holder">

            <div class="sports__loading" v-if="sports.length === 0 && !loading">
                <h5>
                    {{ printString(  'no_sports' ) }}
                </h5>
            </div>

            <ul class="grid three"  v-if="sports.length === 0 && loading">
                <empty-block v-for="index in 12" :key="index"/>
            </ul>

            <ul class="grid three" v-else>
                <Block v-for="(single_sport, index) in sports" :key="index" :sport="single_sport" :id="'sport-' + (index + 1)" />
            </ul>

            <button class="general-button grey-border" :class="{'inactive': loading }" @click="loadMore" v-if="showLoadMore">

                <span class="loading_animation" v-if="loading"></span>
                <span v-html="ico_plus_16" v-else></span>

                <div v-if="loading"> {{printString('loading')}}  </div>
                <div v-else> {{printString('load_more')}} </div>

            </button>

        </div>

    </div>
</template>

<script>
import axios from 'axios';
import { reactive } from 'vue';
import 'select2/dist/js/select2.full.js'
import Block from './Block.vue';
import EmptyBlock from './EmptyBlock.vue';

export default {
    components: {
        Block,
        EmptyBlock
    },
    data() {
      return {

        rest_url                        : window.php_data['rest_url'],
        lang                            : window.php_data['lang'],
        sports                          : [],

        sport_types                     : window.php_data['sport_types'],
        current_page_id                 : window.php_data['current_page_id'],

        arrow_right_alt                 : window.arrow_right_alt,
        ico_plus_16                     : window.ico_plus_16,

        selectedType                    : [],

        reseting                        : false,
        loading                         : true, // add loading state
        page                            : 1, // Initial page
        perPage                         : 15, // Number of posts to fetch per page
        sortedBy                        : "title",
        orderAsc                        : "asc",
        sport_type                      : [],
        isFirstLoad                     : true,
        totalPages                      : 1,
        showLoadMore                    : true,

      };
    },

    computed: {

    },

    mounted() {

        let vm = this;

        this.loadMore().then(() => {
           this.isFirstLoad = false; // Set to false after the initial load
       });

    },


    methods: {

        resetOnSelect(){
            this.reseting = true
            this.loading = true
            // this.sports = []

            this.loadMore();
        },

        async loadMore() {
            this.loading = true;
            if (this.reseting) {
                this.page = 1;
            }

            const response = await this.fetchSportPosts();

            // Check if the received data is already present in the sports array
            const newData = response.data.filter(item => !this.sports.find(existingItem => existingItem.id === item.id));

            // Track the index of the first new element
            const firstNewIndex = this.sports.length;

            // Concatenate only the new data
            this.sports = this.sports.concat(newData);

            if( !this.isFirstLoad ){
                // Use nextTick to ensure DOM update before focusing
                this.$nextTick(() => {
                    if (newData.length > 0) {
                        const firstNewElement = document.getElementById(`sport-${firstNewIndex + 1}`);
                        console.log(firstNewElement)
                        if (firstNewElement) {
                            firstNewElement.scrollIntoView({ behavior: 'smooth' });
                            firstNewElement.focus();
                        }
                    }
                });
            }

            // Update showLoadMore flag based on the length of the new data
            this.showLoadMore = response.data.length >= this.perPage;

            // Check if all pages are loaded
            if (this.page == response.headers['x-wp-totalpages']) {
                this.showLoadMore = false;
            }

            this.page++;
        },

        async fetchSportPosts() {

                try {
                    const params = {
                    order: this.orderAsc,
                    orderby: this.sortedBy,
                    page: this.page,
                    per_page: this.perPage,
                    lang: window.php_data['lang'],
                };

                // Only include sport_type parameter if it's not empty
                if (this.sport_type !== "") {
                    params.sport_type = this.sport_type;
                }

                if( this.current_page_id !== "" ){
                    params.current_page_id = this.current_page_id;
                    // console.log( this.current_page_id );
                }

                const response = await axios.get(`${this.rest_url}/wp-json/wp/v2/sport`, { params });

                if( this.reseting ){
                    this.sports = []
                }

                this.reseting = false;
                this.loading = false;

                return response;
            } catch (error) {
                console.error('Error fetching sport posts:', error);
                return [];
            }
        },

        allOrder(){
            this.sport_type = "";
            this.resetOnSelect();
        },

        filterByType(termId) {
            this.isFirstLoad = false;
            this.sport_type = termId.toString(); // Convert term ID to string
            this.resetOnSelect();

        },

        printString( string ){
            return window.translations[string]
        },
    }
};
</script>
